/* src/app/features/mini-details/components/mini-details.component.scss */
.consent-text {
  font-size: 16px;
}
@media (min-width: 2560px) {
  .consent-text {
    font-size: 19.2px;
  }
}
@media (min-width: 3000px) {
  .consent-text {
    font-size: 23.04px;
  }
}
.font-xxsmall {
  font-size: 12px !important;
}
@media (min-width: 2560px) {
  .font-xxsmall {
    font-size: 14.4px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxsmall {
    font-size: 17.28px !important;
  }
}
.font-xsmall {
  font-size: 13px !important;
}
@media (min-width: 2560px) {
  .font-xsmall {
    font-size: 15.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-xsmall {
    font-size: 18.72px !important;
  }
}
.font-small {
  font-size: 14px !important;
}
@media (min-width: 2560px) {
  .font-small {
    font-size: 16.8px !important;
  }
}
@media (min-width: 3000px) {
  .font-small {
    font-size: 20.16px !important;
  }
}
.font-medium {
  font-size: 16px !important;
}
@media (min-width: 2560px) {
  .font-medium {
    font-size: 19.2px !important;
  }
}
@media (min-width: 3000px) {
  .font-medium {
    font-size: 23.04px !important;
  }
}
.font-large {
  font-size: 18px !important;
}
@media (min-width: 2560px) {
  .font-large {
    font-size: 21.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-large {
    font-size: 25.92px !important;
  }
}
.font-xlarge {
  font-size: 24px !important;
}
@media (min-width: 2560px) {
  .font-xlarge {
    font-size: 28.8px !important;
  }
}
@media (min-width: 3000px) {
  .font-xlarge {
    font-size: 34.56px !important;
  }
}
.font-xxlarge {
  font-size: 28px !important;
}
@media (min-width: 2560px) {
  .font-xxlarge {
    font-size: 33.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxlarge {
    font-size: 40.32px !important;
  }
}
.font-xxxlarge {
  font-size: 36px !important;
}
@media (min-width: 2560px) {
  .font-xxxlarge {
    font-size: 43.2px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxxlarge {
    font-size: 51.84px !important;
  }
}
:root {
  --font-family: Roboto, sans-serif;
  --font-xxsmall: 12px;
  --font-xsmall: 13px;
  --font-small: 14px;
  --font-medium: 16px;
  --font-large: 18px;
  --font-xlarge: 24px;
  --font-xxlarge: 28px;
  --font-xxxlarge: 36px;
  --scale-factor-2560: 1.2;
  --scale-factor-3840: 1.2;
  --button-large: 50px;
  --button-medium: 45px;
  --button-small: 40px;
  --button-xsmall: 35px;
  --button-xxsmall: 30px;
  --header-height: 95px;
  --header-height-scrolled: 80px;
  --sidebar-width: 350px;
  --base-cover-radius: 50px;
  --base-tile-radius: 20px;
  --base-form-radius: 30px;
  --base-programme-tile-radius: 6px;
  --transition-function: cubic-bezier(0.02, 0.01, 0.47, 1);
  --transition-duration-xs: 0.15s;
  --transition-duration-sm: 0.25s;
  --transition-duration: 0.35s;
  --transition-duration-lg: 0.5s;
  --mini-details-z-index: 1100000;
  --player-z-index: 1054;
  --details-z-index: 9999999;
}
:host {
  position: absolute;
  visibility: hidden;
  z-index: 1100000;
}
.timeline {
  transition: width 0.25s ease-out;
  z-index: 1;
  position: absolute;
  bottom: 0px;
  left: 0px;
  height: 5px;
  background-color: var(--player_progress_bar);
}
.mute-button {
  position: absolute;
  bottom: 16px;
  right: 16px;
  z-index: 2;
}
.mini-details-container {
  pointer-events: none;
  height: 432px;
  width: 432px;
  overflow: hidden;
  background-color: var(--background_primary);
  border: 1px solid var(--highlight_primary_2);
  opacity: 0;
  transform: scale(0.75);
  transition:
    transform 0.25s cubic-bezier(0.02, 0.01, 0.47, 1),
    opacity 0.25s cubic-bezier(0.02, 0.01, 0.47, 1),
    visibility 0s linear 0.25s;
}
.mini-details-container.expanded {
  pointer-events: all;
  opacity: 1;
  visibility: visible;
  transform: scale(1);
  transition: transform 0.25s cubic-bezier(0.02, 0.01, 0.47, 1), opacity 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);
}
.mini-details-container.expanded .info {
  cursor: default;
  gap: 10px;
}
.mini-details-container.expanded .metadata > div:not(.categories) {
  display: flex;
  align-items: center;
}
.mini-details-container .poster {
  cursor: pointer;
  position: relative;
  width: 100%;
  height: 242px;
  background-size: cover;
  background-position: top;
}
.mini-details-container .poster .delete-button {
  position: absolute;
  top: 12px;
  right: 16px;
  z-index: 4;
  pointer-events: all;
}
.mini-details-container .poster.has-delete-button badge {
  --badge-offset-inline: max(var(--badge-offset, 12px), 64px);
}
.mini-details-container .poster badge.badge-hidden {
  visibility: hidden;
}
.mini-details-container .poster .video-container {
  position: absolute;
  width: 100%;
  height: 242px;
  overflow: hidden;
  opacity: 0;
  transition: opacity 1s ease;
}
.mini-details-container .poster .video-container.playing {
  transition: opacity 1s ease;
  opacity: 1;
}
.mini-details-container .disable-events {
  pointer-events: none;
}
.mini-details-container .info {
  width: 100%;
  height: 186px;
  background-color: var(--background_tertiary);
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.mini-details-container .info .title {
  margin-bottom: 10px;
  color: var(--text_primary);
}
.mini-details-container .info .description {
  margin-bottom: 10px;
  color: var(--text_primary);
}
.mini-details-container .info .metadata {
  color: var(--text_secondary);
}
.mini-details-container .info .metadata > div:not(:last-child) {
  margin-right: 15px;
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.mini-details-container .info .metadata .categories {
  display: -webkit-box !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  max-width: 100%;
}
:host::ng-deep video {
  width: 100%;
  height: 100%;
}
:host::ng-deep .mini-details-container {
  background-color: var(--background_tertiary);
}
:host::ng-deep .mini-details-container .metadata svg {
  position: relative;
  width: 15px;
  height: 15px;
  margin-right: 5px;
}
:host::ng-deep .mini-details-container .metadata svg path {
  fill: var(--text_secondary);
  stroke: var(--text_secondary);
}
:host::ng-deep .mini-details-container .metadata img {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}
:host::ng-deep .info-button {
  position: absolute;
  right: 16px;
}
:host::ng-deep .info-button-place {
  width: 110px;
}
:host::ng-deep .info-button-place-metadata {
  width: 40px;
}
/*# sourceMappingURL=mini-details.component.css.map */
